var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.39848 1.66675H10.8152C11.4318 1.66675 11.9401 2.17509 11.9401 2.79175V4.02507C11.9401 4.47507 11.6568 5.03342 11.3818 5.31675L8.96519 7.45008C8.63186 7.73342 8.40682 8.29174 8.40682 8.74174V11.1584C8.40682 11.4918 8.18183 11.9418 7.8985 12.1168L7.11516 12.6251C6.38183 13.0751 5.37347 12.5667 5.37347 11.6667V8.69174C5.37347 8.30008 5.14849 7.79176 4.92349 7.50842L2.79016 5.25841C2.50683 4.97508 2.28184 4.47507 2.28184 4.13341V2.84175C2.27351 2.17508 2.78181 1.66675 3.39848 1.66675Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27368 10.0003V12.5003C2.27368 16.667 3.94035 18.3336 8.10701 18.3336H13.107C17.2737 18.3336 18.9403 16.667 18.9403 12.5003V7.50028C18.9403 4.90028 18.2903 3.26695 16.782 2.41695C16.357 2.17528 15.507 1.99194 14.732 1.86694",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4402 10.8333H15.6069",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77368 14.1667H15.607",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestFilter);
export default __webpack_public_path__ + "static/media/test-filter.a880edf307c43ac2f72816984a1a930e.svg";
export { ForwardRef as ReactComponent };